import styled from "styled-components";

export const StyledDialogImage = styled.div`
  margin-bottom: 17px;
  min-height: 80px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -28px;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  box-shadow: 0 5px 18px 0 rgb(0 0 0 / 11%);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ff5757;
  svg {
    color: white;
    fill: white;
  }
`;

export const StyledCheckboxSection = styled.div`
  background: #fafafa;
  border-radius: 6px;
  display: flex;
  padding: 10px;
  align-self: flex-start;
  width: calc(100% - 60px);
  margin: 20px 30px 0 30px;

  p {
    margin-left: 10px;
  }
`;

export const PhraseBuilderWrapper = styled.div`
  background-color: #fafafa;
  padding: 10px 20px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
`;
